export default {
    request_unauthorized: `Authorization failed`,
};